export default "__VITE_ASSET__D0UhQFPn__"